module.exports = __webpack_public_path__ + "static/media/blog-personalization-customer-also-bought.709ffb57.jpg";